import { render, staticRenderFns } from "./RestrictedBlendsCreate.vue?vue&type=template&id=3b0ad5cd&"
import script from "./RestrictedBlendsCreate.vue?vue&type=script&lang=js&"
export * from "./RestrictedBlendsCreate.vue?vue&type=script&lang=js&"
import style0 from "./RestrictedBlendsCreate.vue?vue&type=style&index=0&id=3b0ad5cd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports